import '../Inscription.less';
import { Form, Input, Button, Layout, Row, Col,notification,ConfigProvider} from 'antd';
import { UserOutlined,  EyeInvisibleOutlined, EyeTwoTone, LockOutlined} from '@ant-design/icons';
import React, { useState } from "react";
import cabezal from '../Cabezal.jpg'
import axios from "axios";
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import PropTypes from 'prop-types';
import Foot from "../components/Footer"
import {IP} from '../components/utils';

 async function loginUser(username,password) {
  const data= new FormData()
  data.append('username',username)
  data.append('password',password)
  const response_user= await fetch(IP + `api/casa/usuario/${username}/`,{
    method: "get",
    credentials: "same-origin",
   
  });
  const json_user = await response_user.json();
  if(json_user['detail']){
    return notification.error({
      message:'Error',
      description:'Hubo un error, por favor revise su nombre de usuario y contraseña',})
  }
  if(!json_user.grupos.includes('casaJurado')){
    return notification.error({
      message:'Error',
      description:'Usted no es un jurado'})
  }
  return axios.post(IP + 'api/login/', data).then(data => 
  {
    localStorage.setItem('UserId', json_user.id)
    localStorage.setItem('Jurado', 'casa')
    localStorage.setItem('UserId', json_user.id)
    return data.data
  }).catch(error=> notification.error({
  message:'Error',
  description:'Hubo un error, por favor revise su nombre de usuario y contraseña',
}));};

export default function Login({ setToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const handleSubmit = async(form) => {
    const token = await loginUser(
      username,
      password
    ).catch(error=>console.log(error))
    setToken(token);
    localStorage.setItem('User', username)
  }
    const formItemLayout = {
        labelCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 8,
          },
        },
        wrapperCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 16,
          },
        },
      };
    const {  Content } = Layout;
    return (

      <div className="page-container">
        <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
            <Row>
              <Col><NavLink to="/casa/jurado"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
            </Row>
          <div className="login-wrapper">
          <Content>
              <Form {...formItemLayout} onFinish={handleSubmit} >
              <Row justify="center" align="middle">
                  <Col  xs={{span:22 }}sm={{span:24}} >
                      <Form.Item label="Usuario">
                        <Input
                            placeholder="Introduzca su usuario"
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            onChange={e => setUserName(e.target.value)}
                        />
                      </Form.Item>
                    
                  </Col>
              </Row>
              <Row justify="center" align="middle">
                  <Col   xs={{span:22 }}sm={{span:24}}>
                      <Form.Item label="Contraseña">
                        <Input.Password
                            placeholder="Introduzca su contraseña"
                            prefix={ <LockOutlined />}
                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            onChange={e => setPassword(e.target.value)}
                        />
                      </Form.Item>
                   
                  </Col>
              </Row>
              <Row justify="center" align="middle">
                  <Col   xs={{span:22, offset:9 }}sm={{span:24, offset:15 }}>
                      <Form.Item >
                      <Button htmlType="submit">Login</Button>

                      </Form.Item>
                   
                  </Col>
              </Row>
              </Form>
          </Content>
          </div>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot />
    
    </div>

    );
  }
Login.propTypes = {
  setToken: PropTypes.func.isRequired
};


